<template>
    <div class="simple-form flex col-2">
        <div class="form-group center">
            <div class="form-label">
                <label>姓名</label>
            </div>
            <div class="form-value">
                <span>{{ staffInfo.name || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>员工编号</label>
            </div>
            <div class="form-value">
                <span>{{ staffInfo.no || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>用户手机</label>
            </div>
            <div class="form-value">
                <span>{{ staffInfo.phoneNo || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>联系电话</label>
            </div>
            <div class="form-value">
                <span>{{ staffInfo.contactTel || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>联系邮箱</label>
            </div>
            <div class="form-value">
                <span>{{ staffInfo.contactEmail || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>描述</label>
            </div>
            <div class="form-value">
                <span>{{ staffInfo.memo || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>员工头像</label>
            </div>
            <div class="form-value">
                <ul class="file-area clearfix" v-if="staffInfo.headUuid != null">
                    <li class="file-item show-usage image deletable">
                        <div class="file-content">
                            <img :src="staffInfo.fileBrowseUrl"/>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label></label>
            </div>
            <div class="form-value">
                <span></span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>已禁用</label>
            </div>
            <div class="form-value">
                <span>{{ staffInfo.disabled ? '已禁用' : '已启用' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>禁用描述</label>
            </div>
            <div class="form-value">
                <span>{{ staffInfo.disabledCause || '' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Routes} from '../../app.vues'

    import servicerApi from '../../api/servicer'
    //
    export default {
        name: 'swb-servicer-xStaff-detail',
        desc: '商户员工详情',
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        data: function () {
            //
            return {
                staffInfo: {}
            }
        },
        created: function () {
            if (!Utils.isNoB(this.id)) {
                this.getServicerXStaff();
            }
        },
        methods: {
            getServicerXStaff: function () {
                let self = this;
                servicerApi.getServicerXstaff({
                    id: self.id
                }, function (result) {
                    if (result.type == "info") {
                        let staffInfo = result.data;
                        self.staffInfo = Utils.merge({}, staffInfo);
                    }
                });
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/orgStruct/ServicerXStaffDetail.vue